var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ylQrcode"}},[(_vm.isMobileScreen)?_c('qrCodeMobile',_vm._b({},'qrCodeMobile',_vm.$attrs,false)):_c('ylQrCodePC',_vm._b({},'ylQrCodePC',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }